<micro-tree-select placeholder="Network Elements"
                   [(selectedIds)]="selectedIds"
                   (selectedIdsChange)="change($event)"
                   [structure]="structure"
                   [allowSelection]="allowSelection"
                   [loading]="loading"
>
</micro-tree-select>
